module.exports = __webpack_public_path__ + "static/RobotoMono-LightItalic-a70d962a05476945b46ed8e8acbff4c3.ttf";